import _ from 'underscore';
import React from 'react';
import PropTypes from 'prop-types';
import { QueryParam, withScope } from '@bingads-webui-react/scope-service';
import { getPathName } from '@bingads-webui-campaign-react/page-menu';
import {
  withSiteMap,
  processor,
} from '@bingads-webui-campaign-react/with-site-map';
import { withDefaultLandingPage } from '@bingads-webui-campaign-react/with-default-landing-page';
import { withPreference } from '@bingads-webui-react/preference-context';

class AccountsPage extends React.PureComponent {
  componentDidMount() {
    this.navigate();
  }

  gotoPage = (page) => {
    const pageItem = _.findWhere(this.props.siteMap, { id: page });
    if (!_.isEmpty(pageItem)) {
      const { scope: { history } } = this.props;
      history.replace({
        pathname: getPathName(pageItem),
        search: history.location.search,
      });
    }
  }

  navigate() {
    const { defaultLandingPage } = this.props;

    this.gotoPage(defaultLandingPage);
  }

  render() {
    return null;
  }
}

AccountsPage.propTypes = {
  preferenceService: PropTypes.shape({
    setAtUserLevel: PropTypes.func,
    findByNameAtUserLevel: PropTypes.func,
  }).isRequired,
  scope: PropTypes.instanceOf(QueryParam).isRequired,
  defaultLandingPage: PropTypes.string.isRequired,
  siteMap: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
  })).isRequired,
};

export const AccountsPageNavigation = withSiteMap(withScope(withDefaultLandingPage(withPreference(AccountsPage))), [processor.processPath]);
